import React from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { GameEditorContainer, GameEditorRightAllignetContainer, SectionTitle } from "@components/views/editor/gameEditor/GameEditor.styles";
import { GameFileSelector } from "@components/views/editor/gameEditor/components/GameFileSelector";
import { EventsList } from "@components/views/editor/gameEditor/components/EventsList";
import { GameEditorData } from "@components/views/editor/gameEditor/models/GameEditorData";

interface GameEditorProps {
    data: GameEditorData;
    maxPoints: number;
    onChange: (data: GameEditorData) => void;
}

export const GameEditor = ({ data, maxPoints, onChange }: GameEditorProps) => {
    const { t } = useTranslation();

    const handleFileChange = (fileId: string | null) => {
        onChange({ ...data, fileId });
    };

    const handleEventsChange = (events: GameEditorData["events"]) => {
        onChange({ ...data, events });
    };

    const handleLaunchParamsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange({ ...data, launchParams: e.target.value });
    };

    return (
        <GameEditorRightAllignetContainer>
            <GameEditorContainer>
                <SectionTitle>{t("gameEditor.gameFile")}</SectionTitle>
                <GameFileSelector
                    value={data.fileId}
                    onChange={handleFileChange}
                />
                <SectionTitle>{t("gameEditor.launchParams")}</SectionTitle>
                <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    maxRows={12}
                    value={data.launchParams ?? ""}
                    onChange={handleLaunchParamsChange}
                    placeholder={t("gameEditor.launchParamsPlaceholder")}
                    helperText={t("gameEditor.launchParamsHelper")}
                    variant="outlined"
                    size="small"
                />
                <EventsList
                    events={data.events}
                    maxPoints={maxPoints}
                    onChange={handleEventsChange}
                />
            </GameEditorContainer>
        </GameEditorRightAllignetContainer>
    );
};
